<template>
  <div class="container is-fluid px-5 pt-3">
    <div class="has-text-centered mb-6">
      <div class="has-text-weight-semibold is-size-4 has-text-dark mb-3">
        Efficient Homestay Renovation for Success
      </div>
      <p class="is-6 has-text-dark">
        Transform your homestay with cost-effective renovations that enhance
        functionality and guest comfort. <br />This 4-step guide covers
        essential repairs, upgrades, furnishings, and final touches to maximize
        value and appeal.
      </p>
    </div>
    <div class="main-header has-background-primary" style="border-radius: 1rem">
      <div class="hero-body pt-3 pb-3">
        <div class="header">
          <div class="columns is-multiline is-centered">
            <div class="has-text-left is-12-widescreen">
              <div class="columns is-centered"></div>
              <div class="columns is-multiline">
                <div
                  class="column is-3-widescreen is-6-tablet mb-5 p-5 mt-5 flex-column rounded"
                >
                  <div style="flex: 1">
                    <b-image
                      alt="1"
                      :src="require('@/assets/icon-1.svg')"
                      class="mb-4"
                      style="width: 60px"
                    />

                    <h2 class="title is-4 mb-2 has-text-white">
                      Structural Repairs
                    </h2>
                    <p class="has-text-white is-size-6" style="opacity: 0.75">
                      Ensure walls, ceilings, wiring, and plumbing are in good
                      condition. This forms a solid base and prevents future
                      issues.
                    </p>
                  </div>
                  <b-image
                    class="illustration-build mt-5"
                    :src="require(`@/assets/build-1.jpg`)"
                  />
                </div>
                <div
                  class="column is-3-widescreen is-6-tablet mb-5 p-5 mt-5 flex-column rounded lighter-bg-style"
                >
                  <div style="flex: 1">
                    <b-image
                      alt="2"
                      :src="require('@/assets/icon-2.svg')"
                      class="mb-4"
                      style="width: 60px"
                    />
                    <h2 class="title is-4 mb-2 has-text-white">
                      Install Essentials
                    </h2>
                    <p class="has-text-white is-size-6" style="opacity: 0.75">
                      Set up lighting, Wi-Fi, and necessary appliances like air
                      conditioning and kitchen equipment for functionality.
                    </p>
                  </div>
                  <b-image
                    class="illustration-build mt-5"
                    :src="require(`@/assets/build-2.jpeg`)"
                  />
                </div>
                <div
                  class="column is-3-widescreen is-6-tablet mb-5 p-5 mt-5 flex-column rounded"
                >
                  <div style="flex: 1">
                    <b-image
                      alt="3"
                      :src="require('@/assets/icon-3.svg')"
                      class="mb-4"
                      style="width: 60px"
                    />
                    <h2 class="title is-4 mb-2 has-text-white">
                      Furnish for Comfort
                    </h2>
                    <p class="has-text-white is-size-6" style="opacity: 0.75">
                      Add essential furniture—beds, sofas, tables—along with
                      quality bedding and towels to enhance comfort.
                    </p>
                  </div>
                  <b-image
                    class="illustration-build mt-5"
                    :src="require(`@/assets/build-3.jpg`)"
                  />
                </div>
                <div
                  class="column is-3-widescreen is-6-tablet mb-5 p-5 mt-5 flex-column rounded lighter-bg-style"
                >
                  <div style="flex: 1">
                    <b-image
                      alt="4"
                      :src="require('@/assets/icon-4.svg')"
                      class="mb-4"
                      style="width: 60px"
                    />
                    <h2 class="title is-4 mb-2 has-text-white">
                      Final Touches
                    </h2>
                    <p class="has-text-white is-size-6" style="opacity: 0.75">
                      Optimize with accessories, small electronics,
                      entertainment, and décor to create a welcoming and
                      memorable space.
                    </p>
                  </div>
                  <b-image
                    class="illustration-build mt-5"
                    :src="require(`@/assets/build-4.jpg`)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="has-text-centered mb-2 mt-6">
      <div class="has-text-weight-semibold is-size-3 has-text-dark mb-3">
        Our Styles
      </div>
      <p class="is-6 has-text-dark mx-auto mb-3" style="max-width: 800px">
        Discover a curated selection of interior design styles, tailored to
        bring character and elegance to your space. Find the perfect fit for
        your unique taste. <br />
      </p>
      <b-button type="is-primary is-light" @click="openWhatsApp">
        Contact us now</b-button
      >
    </div>
    <div
      class="columns testimonials is-mobile mt-3 pt-6-desktop is-multiline mb-6"
    >
      <!-- Testimonial 1 -->
      <div class="column is-full-mobile is-6-tablet is-4-desktop">
        <b-image class="" :src="require(`@/assets/style-1.jpg`)" />
      </div>
      <div class="column is-full-mobile is-6-tablet is-4-desktop">
        <b-image class="" :src="require(`@/assets/style-2.jpg`)" />
      </div>
      <div class="column is-full-mobile is-6-tablet is-4-desktop">
        <b-image class="" :src="require(`@/assets/style-3.jpg`)" />
      </div>
    </div>
    <div class="has-text-centered mb-5 mt-6">
      <div class="has-text-weight-semibold is-size-4 has-text-dark mb-3">
        Beyong Investment: Designed for Your Own Stay, Too
      </div>
      <p class="is-6 has-text-dark mx-auto mb-3" style="max-width: 800px">
        Whether for short-term rentals or your own home, we craft designs that
        combine comfort and cost-efficiency. Simple yet stylish, tailored to
        maximize your space while keeping budgets in check. Perfect for those
        seeking a beautiful, hassle-free setup. <br />
      </p>
      <b-button type="is-primary is-light" @click="openWhatsApp">
        Contact us now</b-button
      >
    </div>
    <div class="mx-auto mb-6" style="max-width: 888px">
      <b-image class="rounded" :src="require(`@/assets/move-in-banner.jpg`)" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    openWhatsApp() {
      // Replace this link with your WhatsApp number (including country code)
      const whatsappLink =
        "https://wa.me/60172280613?text=Hi%2C%20I%20came%20across%20your%20website%20and%20would%20love%20to%20learn%20more%20about%20your%20services.";
      window.open(whatsappLink, "_blank");
    },
  },
};
</script>

<style>
.flex-column {
  display: flex !important;
  flex-direction: column !important;
}

.lighter-bg-style {
  background: #4971e2;
}
</style>
